import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import * as productActions from 'redux/modules/products';
import * as supErrActions from 'redux/modules/supervisionErrors';
import { Panel, Col, Button, Alert, Row } from 'react-bootstrap';
import { analyseState } from 'utils/analyseState';
import { ResumePanel } from 'components';
import _ from 'underscore';
import { routeActions } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import { ErrorAlert, STSGoogleMap, LastActivityTable } from 'components'
import { translate } from 'react-i18next';

@translate(['common'])
@connect(state => ({
	user: state.auth.user,
	fiches: state.fiches.data,
	products: state.products.data,
	timelineData: state.timelineEvents.data,
	lastActivityOptions: state.fiches.lastActivityOptions,
	loading:state.products.loading,

}),
	dispatch => bindActionCreators({ ...productActions, ...routeActions, ...supErrActions }, dispatch)
)

/*
@asyncConnect([{

	promise: ({ store: { dispatch, getState }, params }) => {
		const promises = [];
		promises.push(this.props.loadProducts(1, params));
		//promises.push(dispatch(timelineEventsActions.load(params, moment().subtract('10', 'd').unix(), moment().unix())));
		return Promise.all(promises);
	}
}])
*/

export default class Home extends Component {

	componentDidMount() {

		if (this.props.user && this.props.user.role) {
			if (this.props.user.role.indexOf('client') > -1 || this.props.user.role == 'demo' || this.props.user.role.indexOf('user') > -1) {

				if (this.props.products.length == 0 ) {
					this.props.load(0, this.props.params)
				}
				
				//this.props.loadSupervisionErrors('all', this.props.params)
			}
		} else {

			this.props.push('/login')

		}
	}

	render() {
		

		const { user, timelineData, params, t, loading } = this.props;

		const styles = require('./Home.scss');


		var productsByAddr =
			_.groupBy(
				this.props.products.filter(
					(p) => p.identification_fosse < 1),
				(p) => p.localisation_GPS
			)


		productsByAddr = _.omit(productsByAddr, '', null)


		return (
			<div className={styles.home}>
				<Helmet title="Home" />
				<div className="container">
					{!user &&
						<Col xs={12} md={12}>
							<Link to='login'>
								{/*t('content.please_connect')*/}
							</Link>
						</Col>
					}

					{user && user.role && ((user.role.indexOf('client') > -1 || user.role == 'demo' || user.role.indexOf('user') > -1)) &&
						<div>
							{/*<h2>Tableau de bord</h2>*/}
							{this.props.error &&
								<ErrorAlert buttonText={t("dashboardView.reload_page")} callback={() => this.props.load(0, {})} />
							}

							{(user && user.role.indexOf('user') > -1) &&
								<div>
									<h3>
										{t("home.espace_user")} &nbsp;

										{this.props.loading &&
											<i className={'fa ' + 'fa-spinner fa-spin'} />
										}

										
										
									</h3>
								</div>
							}


							{(user && user.role.indexOf('client') > -1 || user.role == 'demo') &&
								<div>
									<h3>{t("home.welcome")}</h3>
								</div>
							}


							<ResumePanel push={this.props.push} />

							{/*

							<Row>
								<Col xs={12} md={12}>
									<h3>Les 5 derniers jours : </h3>
								</Col>
							</Row>

							<Row>
								{generateTable(this.props, timelineData.filter((t) => t.type == 'panne'), 'panne', 'pannes')}

								{generateTable(this.props, timelineData.filter((t) => t.type == 'usager'), 'usager', 'usagers bloqués')}

								{generateTable(this.props, timelineData.filter((t) => t.type == 'indisponible'), 'indisponible', 'sts indisponibles')}

							</Row>

							*/}

							<Row>
								{this.props.products.length > 0 &&
									<Col xs={12} md={12}>
										<h3>{t("home.products_map")}</h3>

										<STSGoogleMap
											groups={productsByAddr}
											user={user} push={this.props.push}
											params={this.props.params}
										/>

									</Col>
								}
							</Row>
						</div>
					}



				</div>
			</div>
		);
	}
}



const generateTable = ({ params, dispatch, lastActivityOptions, setLastActivityOptions }, data, type, title) => {
	var content = []
	var header = <h4>{data.length} {title}</h4>

	if (data.length > 0) {
		content.push(
			<LastActivityTable
				data={data}
				title={title}
				type={type}
				params={params}
				style="primary"
				dispatch={dispatch}
			/>
		)
	}



	return (
		<Col xs={12} md={5}>
			<Panel bsStyle="danger"
				header={header} collapsible
				expanded={lastActivityOptions[type].open}
				onClick={() => setLastActivityOptions(type, !lastActivityOptions[type].open)}>
				{content}
			</Panel>
		</Col>


	)

}


